'use client';

import { AppShell, Container, Group } from '@mantine/core';

import { TrackedButton } from '@/components';
import { useFooter } from '@/contexts';

import styles from './AppFooter.module.css';

const AppFooter = () => {
  const {
    buttonPrimaryProps: {
      children: buttonPrimaryChildren,
      ...otherButtonPrimaryProps
    },
    buttonSecondaryProps: {
      children: buttonSecondaryChildren,
      ...otherButtonSecondaryProps
    },
  } = useFooter();

  // Don't render the footer if no button text is provided
  if (!buttonPrimaryChildren && !buttonSecondaryChildren) {
    return null;
  }

  return (
    <AppShell.Footer styles={{ footer: { border: 0 } }}>
      <Container
        size="xs"
        classNames={{ root: styles.footerContainer }}
      >
        <Group
          justify="center"
          gap="md"
          hiddenFrom="md"
          classNames={{ root: styles.footerGroup }}
        >
          {buttonSecondaryChildren && (
            <TrackedButton
              size="lg"
              className={styles.button}
              {...otherButtonSecondaryProps}
            >
              {buttonSecondaryChildren}
            </TrackedButton>
          )}

          {buttonPrimaryChildren && (
            <TrackedButton
              size="lg"
              className={styles.button}
              {...otherButtonPrimaryProps}
            >
              {buttonPrimaryChildren}
            </TrackedButton>
          )}
        </Group>
      </Container>
    </AppShell.Footer>
  );
};

export { AppFooter };
